/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import GenericFilter from '@techsoftware/happay-widgets/GenericFilter';
import Button from '@techsoftware/happay-widgets/Button';
import DialogBox from '@techsoftware/happay-widgets/DialogBox';
import Tags from '@techsoftware/happay-widgets/Tags';
// import { Popup, Icons, GenericFilter } from '@techsoftware/happay-widgets';
// import SearchFilter from '../../containers/searchFilterContainer';
import { deepClone } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import history from '../../utils/history';
import { FilterShimmer } from '../shimmering';
export default class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false,
      dialogBox: false,
      tags: [],
    };
    // this.closeFilterDialog = this.closeFilterDialog.bind(this);
    // this.toggleFilterDropdown = this.toggleFilterDropdown.bind(this);
    this.handleEtlDownload = this.handleEtlDownload.bind(this);
    this.onDialogboxClose = this.onDialogboxClose.bind(this);
    this.handleEtlSubmit = this.handleEtlSubmit.bind(this);
    this.handleAddition = this.handleAddition.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.saveOpen = false;
    this.filterQuery = {};
    this.pathname =
      (history && history.location && history.location.pathname) || '';
  }

  // toggleFilterDropdown() {
  //   if (!this.state.showDropdown) {
  //     this.setState({ showDropdown: !this.state.showDropdown });
  //   }
  // }

  // componentDidMount() {
  //   const { content_type, hasRole, nativeFilters } = this.props;
  //   console.log(content_type,'did mount')
  //   const query = {
  //     content_type:content_type,
  //     ...(hasRole && { has_role: true }),
  //   };
  //   if(!nativeFilters){
  //     this.props.getAllFilters(query);
  //   }
  //   this.props.getAllSaveFilters(query);
  // }

  componentDidUpdate(prevProps, prevState) {
    const {
      content_type: contentType,
      filterQuery = {},
      content_key,
      pathname,
    } = this.props;
    if (contentType && prevProps.content_type !== contentType) {
      this.emptyAllFilterState();
      const { content_type, hasRole } = this.props;
      const query = {
        content_type,
        ...(hasRole && { has_role: true }),
      };
      if (prevProps.content_type || pathname !== prevProps.pathname) {
        // tab changed
        this.filterQuery = {};
      } else if (!prevProps.content_type) {
        // component is unmounted and we are resetting the filterquery
        this.filterQuery = filterQuery;
      }
      this.props.getAllSaveFilters(query);
    }
  }

  componentWillUnmount() {
    this.emptyAllFilterState();
  }

  emptyAllFilterState() {
    this.props.resetQuery({});
    this.props.SelectedSaveFilter({});
    this.props.storeAppliedFilter({});
    this.props.clearFields();
    this.filterQuery = {};
  }

  // closeFilterDialog(event) {
  //   if (!this.saveOpen) {
  //     this.setState({ showDropdown: false });
  //   }
  // }

  onDialogboxClose(event) {
    this.setState({ dialogBox: false, tags: [] });
  }

  handleEtlDownload(event) {
    this.setState({ dialogBox: true });
    // const { defaultQuery, hasRole, count } = this.props;
    // const filerData = { ...defaultQuery, ...this.filterQuery };
    // const query = {
    //   query: Object.keys(filerData).length
    //     ? JSON.stringify(filerData)
    //     : undefined,
    //   content_type: this.props.content_type,
    //   count,
    //   view_type: hasRole ? 'Privileged' : 'Employee',
    //   cc_users: JSON.stringify([]),
    // };
    // if (this.pathname === '/expenses/othersexpenses') {
    //   query.data_type = 'all';
    // }
    // this.props.downloadEtl(query);
  }

  onFieldTypeChange = type => {
    const {
      getFieldType,
      getFieldDropDownData,
      content_key,
      hasRole,
    } = this.props;
    getFieldType(type);
    const data = {
      query: {
        content_type: content_key,
      },
      url: type.url,
    };
    if (hasRole) {
      data.query.has_role = true;
    }
    if (type.url) {
      getFieldDropDownData(data);
    }
  };

  handleEtlSubmit() {
    event.stopPropagation();
    event.preventDefault();
    const {
      defaultQuery,
      hasRole,
      count,
      content_key,
      content_type,
    } = this.props;
    const filerData = { ...defaultQuery, ...this.filterQuery };
    const { tags } = this.state;
    if (tags.length === 0) {
      return false;
    }
    const emailIds = tags.map(item => item.text);
    let url = '';
    if (content_key === 'invoice') {
      url = 'INVOICE_EXPORT';
    } else {
      url = 'VENDOR_EXPORT';
    }
    const query = {
      query: Object.keys(filerData).length
        ? JSON.stringify(filerData)
        : undefined,
      content_type,
      view_type: hasRole ? 'Privileged' : 'Employee',
      cc: JSON.stringify(emailIds),
    };
    // count,
    // if (this.pathname === '/expenses/othersexpenses') {
    //   query.data_type = 'all';
    // }
    this.props.downloadEtl(query, url);
    this.setState({ dialogBox: false, tags: [] });
  }

  handleAddition(textVal, listVal) {
    const emailRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
    const id = textVal?.text || '';
    // console.log(textVal, listVal);
    if (id && emailRegex.test(id)) {
      this.setState({
        tags: listVal,
      });
    }
  }

  handleDelete(index, stateValue) {
    this.setState({ tags: stateValue });
  }
  handleKeyPress = event => {
    if (event.charCode === 13) {
      this.handleEtlDownload();
    }
  };
  render() {
    const { showDropdown, dialogBox, tags } = this.state;
    const {
      shimmer,
      isEtl,
      saveFilters,
      filters,
      field = {},
      choices,
      content_type,
      hasRole,
      nativeFilters,
    } = this.props;

    const choice = {
      [field.meta_id]: choices,
    };
    return shimmer ? (
      <>
        {isEtl && (
          <FilterShimmer className="margin-t-16 margin-r-20 margin-l-12" />
        )}
        <FilterShimmer
          className={`${isEtl ? 'margin-r-60' : 'margin-r-10'} margin-t-16`}
        />
      </>
    ) : (
      <div className="flex-center float-right margin-t-10 margin-r-50 genericFilter">
        {/* margin-r-50 add this margin to make space for col management */}
        {isEtl && (
          <div
            className="pointer margin-r-6 hw-tooltip hw-bottom-right filter-tooltip hw-top"
            data-tooltip="Export Data"
            onClick={this.handleEtlDownload}
            onKeyPress={this.handleKeyPress}
          >
            <Icons
              type="download"
              size="large"
              className="font-22"
              interactive
              tabIndex={0}
            />
          </div>
        )}
        <GenericFilter
          filters={nativeFilters || filters}
          field={field}
          choices={choice}
          onTypeChange={this.onFieldTypeChange}
          variant="primary"
          showSaveFilters
          tooltipText="Filters"
          saveFilters={saveFilters || []}
          // selected={this.state.selected}
          onTypeReset={() => {
            this.props.applyFilter({});
            this.emptyAllFilterState();
          }}
          filterQuery={deepClone(this.filterQuery)}
          onSaveFilterClick={filter => {
            let { query } = filter;
            this.filterQuery = query;
            this.props.applyFilter(query);
            // this.props.applyQueryFilter(filter);
          }}
          onFilterSave={obj => {
            let { query } = obj;
            const { hasRole } = this.props;
            let tempQuery = {};
            if (Object.keys(query).length) {
              tempQuery = query;
            } else {
              tempQuery = this.filterQuery;
            }
            if (Object.keys(tempQuery).length) {
              this.props.applySaveFilter({
                content_type,
                query: JSON.stringify(tempQuery),
                name: obj.name,
                ...(hasRole && { has_role: true }),
              });
            } else {
              // code to show snackbar goes here .
              this.props.showSnackbar({
                msg: 'Please apply some filter to save',
                type: 'error',
              });
            }
          }}
          onApply={query => {
            // this.props.applyQueryFilter({
            //   query: JSON.stringify(query),
            //   content_type,
            //   has_role: hasRole,
            // });
            query = { ...this.filterQuery, ...query };
            this.props.applyFilter(query);
            this.filterQuery = query;
            // this.setState({ showDropdown: false });
          }}
          // onFilterClose={(initialFilterData) => {
          //   this.filterQuery = initialFilterData;
          //   console.log(initialFilterData, 'sdusjhsd hsjdk sdhj');
          // }}
        />
        {/* <span
          onClick={this.toggleFilterDropdown}
          className={`pointer ${this.props.cardTxn ? 'margin-r-20' : ''}`}
          id="filterPopupIcon"
        >
          <Icons
            className={showDropdown ? 'primary-green-color' : ''}
            type="filter"
            size="large"
          />
        </span>
        <Popup
          id="filterPopup"
          parentElementId="filterPopupIcon"
          open={showDropdown}
          onClose={this.closeFilterDialog}
          pointerPlacement="top-right"
          variant="scroll"
          popupStyle={{
            width: '513px',
            right: '-10px',
            top: '24px',
            zIndex: '200',
          }}
        >
          <SearchFilter
            {...this.props}
            onApply={query => {
              this.filterQuery = query;
              this.setState({ showDropdown: false });
            }}
            onClose={this.closeFilterDialog}
            onSaveFilterOpen={open => {
              this.saveOpen = open;
            }}
            filterQuery={this.filterQuery}
          />
        </Popup> */}
        {/* {showDropdown && (
          <SearchFilter {...this.props} onClose={this.closeFilterDialog} />
        )} */}
        <DialogBox
          open={dialogBox}
          id="167189"
          onClose={this.onDialogboxClose}
          title="Download"
          titleStyle={{ fontWeight: 500 }}
          bodyStyle={{ letterSpacing: '0.25px' }}
          dialogTitleContainerStyle={{ fontWeight: '600' }}
          actionBorder
          crossIcon
          height="300px"
          width="600px"
          actions={
            <div>
              <Button
                type="button"
                text="Cancel"
                variant="secondary"
                size="medium"
                className="margin-r-10"
                onClick={this.onDialogboxClose}
              />
              <Button
                disabled={tags.length === 0}
                type="button"
                text="Submit"
                size="medium"
                onClick={this.handleEtlSubmit}
              />
            </div>
          }
        >
          <div className="margin-20">
            <Tags
              tags={tags}
              handleAddition={this.handleAddition}
              handleDelete={this.handleDelete}
              floatingLabelText="Enter Mail ID"
              hintText="Enter Mail ID"
            />
          </div>
        </DialogBox>
      </div>
    );
  }
}

Filter.propTypes = {
  resetQuery: PropTypes.func,
  SelectedSaveFilter: PropTypes.func,
  storeAppliedFilter: PropTypes.func,
  isEtl: PropTypes.bool,
  count: PropTypes.number,
  defaultQuery: PropTypes.object,
  hasRole: PropTypes.bool,
  content_type: PropTypes.string,
  downloadEtl: PropTypes.func,
  shimmer: PropTypes.bool,
  field: PropTypes.object,
  getAllFilters: PropTypes.func,
  getAllSaveFilters: PropTypes.func,
  getFieldType: PropTypes.func,
  getFieldDropDownData: PropTypes.func,
  saveFilters: PropTypes.array,
  filters: PropTypes.array,
  choices: PropTypes.object,
  applyQueryFilter: PropTypes.func,
  applySaveFilter: PropTypes.func,
  nativeFilters: PropTypes.array,
  applyFilter: PropTypes.func,
};

Filter.defaultProps = {
  isEtl: false,
  defaultQuery: {},
  shimmer: false,
  nativeFilters: null,
  applyFilter: () => {},
};
